<template>
  <div class="exception">
    <div class="img">
      <img :src="config[type].img">
    </div>
    <div class="content">
      <h1 class="title">{{ config[type].title }}</h1>
      <h1 class="desc">{{ config[type].desc }}</h1>
      <div class="action">
        <a-button @click="handleToHome">重新加载</a-button>
      </div>
    </div>
  </div>
</template>

<script>
import types from './type'

export default {
  name: 'Exception',
  props: {
    type: {
      type: String,
      default: '404'
    }
  },
  data () {
    return {
      config: types
    }
  },
  methods: {
    handleToHome () {
      this.$router.go(0)
    }
  }
}
</script>

<style lang="scss" scoped>
.exception {
  height: 100%;
  width: 750px;
  text-align: center;
  padding-top: 160px;
  box-sizing: border-box;
  display: flex;
  margin: 0 auto;
  img{
    margin-right: 116px;
  }
  .content {
    display: inline-block;
    text-align: left;
    .title{
      font-size: 56px;
      font-weight: 500;
      color: #000000;
    }
    .desc {
      color: rgba(0, 0, 0, 0.45);
      font-size: 16px;
      margin-bottom: 24px;
    }
    .action{
      /deep/ button{
        width: 88px;
        height: 32px;
        background: $choose-color;
        border-radius: 2px;
        font-size: 14px;
        font-weight: 400;
        color: $font-color;
      }
    }
  }
}

</style>
